import http from 'utils/http'

const getOrders = () => http.get('/order/v1/order/deliverytracking')

export default {
  getOrders
}



// WEBPACK FOOTER //
// ./src/services/deliveryTrackingService.js